import { initSegement, segmentTrackLessonCompletion } from "./segment";

import identifyPage from "./identifyPage";

import injectPromoBanner from "./promo-banner";
import injectNavBar, { addTagline } from "./navbar";
import injectMobileBanner from "./mobile-banner";
import updateSJCards from "./cards";
import injectFooter from "./footer";
import updateCoursePages from "./courses";
import addComingSoonTags from "./coming-soon";
import handleTimeEstimates from "./time-estimates";
import updatePathPages from "./learning-path";
import updatePartnerNavLinks from "./partner-nav";
import checkForPartnerGroup from "./partner-check";

import injectHomePage from "./page/homepage";
import injectPartnerPage from "./page/partners";
import updateProfilePage from "./page/profile";
import updateClickTipsPage from "./page/clicktips";
import updatePaywall from "./page/paywall";
import updateCourseCatalog from "./page/course-catalog";
import updateGuestsPage from "./page/guests";
import updateCertificatesPage from "./page/certificates";
import updateCertificatesTestPage from "./page/certificates_2024";
import updateLiveTrainingPage from "./page/live-training";

// ================ //
// sitewide updates //
// ================ //

// segment tracking
segmentTrackLessonCompletion();

// Adds a ids/classes to the body based on page/path
// ** MUST COME BEFORE ANY OTHER PAGE UPDATE CODE **
identifyPage();

// navigation bar
try {
  injectNavBar();
} catch (e) {
  console.error("Couldn't add navigation bar!", e);
}

try {
  addTagline("The everything<br>app for work.");
} catch (e) {
  console.error("Couldn't add tagline!", e);
}

// mobile banner message
injectMobileBanner();

// SJ course cards
updateSJCards();

// "Coming Soon" card tags
addComingSoonTags();

// Time estimate tags
handleTimeEstimates();

// inject footer
injectFooter();

let body = document.body;

// ================ //
// add promo banner //
// ================ //

// ...to the homepage
if (body.classList.contains("home-page")) {
  injectPromoBanner();
}

// ==================== //
// update section pages //
// ==================== //

// learning path pages
if (document.body.classList.contains("learning-path-page")) {
  updatePathPages();
}

// courses pages
if (body.classList.contains("sj-page-series")) {
  updateCoursePages();
}

// ======================= //
// update individual pages //
// ======================= //

// homepage
if (body.classList.contains("home-page")) {
  injectHomePage();
}

// partners page
if (body.classList.contains("partners")) {
  injectPartnerPage();
  updatePartnerNavLinks();
}

// partner nav updates
if (body.classList.contains("partner-development")) {
  updatePartnerNavLinks();
}

// sitewide nav updates for student in a partner group
if (checkForPartnerGroup()) {
  updatePartnerNavLinks();
}

// profile page
if (body.classList.contains("sj-page-profile")) {
  updateProfilePage();
}

// course catalog / all courses page
if (body.classList.contains("course-catalog")) {
  updateCourseCatalog();
}

// clicktips page
if (body.classList.contains("clicktips")) {
  updateClickTipsPage();
}

// guests-start-here page
if (body.classList.contains("guests-start-here")) {
  updateGuestsPage();
}

// update course purchase checkout page
if (body.classList.contains("sj-page-checkout")) {
  updatePaywall();
}

// update certificates page
if (body.classList.contains("certificates")) {
  updateCertificatesPage();
}

// update new certificates page
if (body.classList.contains("clickup-certificates-page")) {
  updateCertificatesTestPage();
}

// update live training page
if (body.classList.contains("live-training")) {
  updateLiveTrainingPage();
}

// TODO: Finish deprecating or refactoring all code below into modules

// ================================================== //
// create page headers for custom search filter pages //
// ================================================== //

try {
  let pageList = [
    "productivity-expert",
    "productivity-all-star",
    "productivity-pro",
    "use-cases",
    "webinars",
  ];

  for (let page of pageList) {
    if (body.classList.contains(page)) {
      let mainContainer = document.querySelector("#main-container");
      let pageHeader = document.createElement("H1");
      let searchContainer = document.querySelector(".search-container");
      let subtext = document.createElement("H2");

      switch (page) {
        case "productivity-expert":
          pageHeader.innerText = "Productivity Expert";
          subtext.innerText =
            "As a ClickUp Productivity Expert, you'll have all the admin skills you need to manage and configure your Workspace with ease.";
          break;
        case "productivity-all-star":
          pageHeader.innerText = "Productivity All-Star";
          subtext.innerText =
            "As a ClickUp Productivity All-Star, you'll have all the skills you need to build the most efficient Workspace and optimize your workflow.";
          break;
        case "productivity-pro":
          pageHeader.innerText = "Productivity Pro";
          subtext.innerText =
            "Take a deeper dive into core features and productivity tips to grow your skills and earn ClickUp badges.";
          break;
        case "use-cases":
          pageHeader.innerText = "Use Cases";
          subtext.innerText =
            "Choose the ClickUp use case for your business goals. Each learning path includes courses of varying levels.";
          break;
          break;
        case "webinars":
          pageHeader.innerText = "On-Demand Webinars";
          subtext.innerText = "";
          break;
        // case 'clicktips':
        //     pageHeader.innerText = 'ClickTips'
        //     subtext.innerText = "Get quick tips and tutorials to help you reach your productivity goals with ClickUp.";
        //     break;
        default:
          break;
      }

      searchContainer.prepend(pageHeader);
      searchContainer.append(subtext);
      mainContainer.prepend(searchContainer);
      break;
    }
  }
} catch {}

// ================================================== //
// add functionality to show and hide the lesson menu //
// ================================================== //

try {
  let lessonPage = document.querySelector(".sj-page-lesson #main-container");
  let menuBtn = document.createElement("div");
  let lessonMenu = document.querySelector(".sj-page-lesson #lp-left-nav");
  menuBtn.id = "menu-btn";
  menuBtn.addEventListener("click", () => {
    if (lessonMenu.style.display === "block") {
      lessonMenu.style.display = "none";
    } else {
      lessonMenu.style.display = "block";
    }
  });
  lessonPage.prepend(menuBtn);
} catch {}

// ============================== //
// add breadcrumbs to plans pages //
// ============================== //

try {
  let planHeader = document.querySelector(".plans-page .dp-summary-wrapper");
  let breadcrumbs = document.createElement("div");
  breadcrumbs.id = "plan-breadcrumbs";
  breadcrumbs.innerHTML = `
        <a class="home-link" href="/">Home</a>
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M1 3.99631H12.5895L10.3003 1.70711C9.90982 1.31658 9.90982 0.683417 10.3003 0.292893C10.6909 -0.0976314 11.324 -0.0976307 11.7146 0.292894L15.707 4.2853C15.8921 4.4704 15.9894 4.71001 15.9991 4.95245C15.9997 4.96699 16 4.98161 16 4.99631C16 5.27773 15.8838 5.53199 15.6967 5.71371L11.707 9.70339C11.3165 10.0939 10.6833 10.0939 10.2928 9.70339C9.90225 9.31286 9.90225 8.6797 10.2928 8.28917L12.5856 5.99631H1C0.447715 5.99631 0 5.54859 0 4.99631C0 4.44402 0.447715 3.99631 1 3.99631Z" fill="#B9BEC7"/>
        </svg>
        <a class="live-training-link" href="/page/live-training">Live Training</a>
    `;

  planHeader.prepend(breadcrumbs);
} catch {}

// ===================================== //
// add breadcrumbs to plan catalog pages //
// ===================================== //

try {
  let planHeader = document.querySelector(
    ".getting-started-with-clickup-workshop-bundle .catalog-header",
  );
  let breadcrumbs = document.createElement("div");
  breadcrumbs.id = "plan-breadcrumbs";
  breadcrumbs.innerHTML = `
        <a class="home-link" href="/">Home</a>
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M1 3.99631H12.5895L10.3003 1.70711C9.90982 1.31658 9.90982 0.683417 10.3003 0.292893C10.6909 -0.0976314 11.324 -0.0976307 11.7146 0.292894L15.707 4.2853C15.8921 4.4704 15.9894 4.71001 15.9991 4.95245C15.9997 4.96699 16 4.98161 16 4.99631C16 5.27773 15.8838 5.53199 15.6967 5.71371L11.707 9.70339C11.3165 10.0939 10.6833 10.0939 10.2928 9.70339C9.90225 9.31286 9.90225 8.6797 10.2928 8.28917L12.5856 5.99631H1C0.447715 5.99631 0 5.54859 0 4.99631C0 4.44402 0.447715 3.99631 1 3.99631Z" fill="#B9BEC7"/>
        </svg>
        <a class="live-training-link" href="/page/live-training">Live Training</a>
    `;

  planHeader.prepend(breadcrumbs);
} catch {}

// ============================================= //
// add plan labels to course cards on plan pages //
// ============================================= //

const generatePlanLabel = (allLabels) => {
  let labelOptions = {
    "all-plans": "All Plans",
    "free-forever": "Free Forever",
    unlimited: "Unlimited",
    business: "Business",
    "business-plus": "Business Plus",
    enterprise: "Enterprise",
  };
  let formattedLabels = [];

  for (let label of allLabels) {
    if (labelOptions[label]) {
      formattedLabels.push(labelOptions[label]);
    }
  }

  if (formattedLabels.length > 1 || formattedLabels[0] === "All Plans") {
    return `Plans: <strong>${formattedLabels.join(", ")}</strong>`;
  } else if (formattedLabels.length === 0) {
    return "";
  }

  return `Plan: <strong>${formattedLabels.join(", ")}</strong>`;
};

try {
  let allCourseCards = document.querySelectorAll(
    ".getting-started-with-clickup-workshop-bundle a.coursebox-container",
  );

  for (let card of allCourseCards) {
    let label = document.createElement("div");
    label.classList.add("plan-label");
    label.innerHTML = generatePlanLabel(card.dataset.tags.split(","));

    for (let child of card.children) {
      if (child.classList.contains("coursebox-text")) {
        child.prepend(label);
      }

      // Update button text
      if (
        child.classList.contains("coursebox-callout") &&
        !child.classList.contains("course-time")
      ) {
        child.innerHTML = "View";
      }
    }
  }
} catch {}

// ===================================================== //
// add functionality to hide lessons from search results //
// ===================================================== //

/**
 * This function was provided by SkillJar
 * to handle missing functionality in the Admin UI
 */
$(document).ready(function () {
  $("#catalog-search-box").on("keydown", function () {
    $("#catalog-courses").find($(".lesson")).remove();
    $("#filter_type_-l").hide();
    $("#filter_type_-c").hide();
    $("#filter_type_-p").hide();
  });
  if (window.location.href.includes("q=")) {
    $("#catalog-courses").find($(".lesson")).remove();
    $("#filter_type_-l").hide();
    $("#filter_type_-c").hide();
    $("#filter_type_-p").hide();
  }
});

// ===================================================== //
// add a button and popup modal to most pages to allow a //
// user to see all of their in-progress courses          //
// ===================================================== //

/**
 * This is a code snippet provided by SkillJar
 * to add a button and popup modal to most pages
 * to allow a user to see all of their in-progress courses
 *
 * Related learning article:
 * https://developer.skilljar.com/add-your-learning-floating-popup-button-to-show-learners-active-courses/1615373?reg=1
 */
var yourLearningPopupConfig = {
  popupHeaderText: "Resume Your Learning" /* text content of header */,
  popupSubHeaderText:
    "Click on the courses below to pick up where you left off." /* text content of sub-header */,
  popupBackgroundColor: "#FFFFFF" /* background color of pop-up */,
  popupTextColor: "#000000" /* color of text in pop-up */,
  buttonText: "View Active Courses" /* text content of button */,
  buttonBackgroundColor: "#0166CC" /* background color of floating button */,
  buttonTextColor: "#FFFFFF" /* text color of floating button */,
  buttonPosition:
    "left" /* defaults to bottom left. change to 'right' for bottom right */,
};

function showLearningPopup() {
  /* add popup to page and configure it if it doesn't exist yet */
  if (!$(".your-learning").length) {
    var yourLearningPopup = `
      <div class="your-learning-popup">
        <div class="your-learning-popup-content">
          <span class="your-learning-popup-close">&times;</span>
          <div class="your-learning-popup-html"></div>
        </div>
      </div>
    `;

    var yourLearningPopupHTML = `
      <div class="your-learning">
        <div class="your-learning-header"></div>
        <div class="your-learning-sub-header"></div>
        <div class="your-learning-scroll-wrapper">
          <div class="yl-left-scroll-btn"><i class="fa fa-arrow-circle-o-left" aria-hidden="true"></i></div>
          <div class="yl-right-scroll-btn"><i class="fa fa-arrow-circle-o-right" aria-hidden="true"></i></div>
        </div>
        <div class="your-learning-content"></div>
      </div>
    `;

    /* append popup to DOM and apply config */
    $("body").append(yourLearningPopup);
    $(".your-learning-popup-html").html(yourLearningPopupHTML);
    $(".your-learning-popup-html .your-learning-header").html(
      yourLearningPopupConfig.popupHeaderText,
    );
    $(".your-learning-popup-html .your-learning-sub-header").html(
      yourLearningPopupConfig.popupSubHeaderText,
    );

    /* populate popup with in progress courses */
    $(".coursebox-container").each(function () {
      /* course logic */
      if ($(this).attr("data-course-status") == "registered") {
        /* start logic to prevent duplicate courses from showing up */
        var that = $(this);
        var duplicateCourse = false;
        $(".your-learning-content")
          .find($(".coursebox-container"))
          .each(function () {
            if ($(this).attr("title") == that.attr("title")) {
              duplicateCourse = true;
            }
          });

        /* if course doesn't already exist, add it to the widget */
        if (duplicateCourse == false) {
          $(".your-learning-content").append(
            $(this).clone().removeClass("search-only not-found"),
          );
        }
      }
      /* path logic */
      if (
        $(this).hasClass("sj-path") &&
        $(this).find(".sj-ribbon-registered").length
      ) {
        /* start logic to prevent duplicate courses from showing up */
        var that = $(this);
        var duplicatePath = false;
        $(".your-learning-content")
          .find($(".coursebox-container"))
          .each(function () {
            if ($(this).attr("title") == that.attr("title")) {
              duplicatePath = true;
            }
          });

        /* if course doesn't already exist, add it to the widget */
        if (duplicatePath == false) {
          $(".your-learning-content").append(
            $(this).clone().removeClass("search-only not-found"),
          );
        }
      }
    });
    /* add total courses counter text */
    $(".yl-left-scroll-btn").before(
      '<div class="yl-course-counter">' +
        $(".your-learning-content .coursebox-container").length +
        " Active Courses",
    );

    /* add click listeners for your learning scroll buttons */
    $(".yl-left-scroll-btn").click(function () {
      $(".your-learning-content").animate(
        {
          scrollLeft: "-=600px",
        },
        "fast",
      );
    });

    $(".yl-right-scroll-btn").click(function () {
      $(".your-learning-content").animate(
        {
          scrollLeft: "+=600px",
        },
        "fast",
      );
    });

    // close popup if user clicks X button
    $(".your-learning-popup-close").click(function () {
      $(".your-learning-popup").fadeOut("fast");
    });

    // close popup if user clicks outside of it
    $(".your-learning-popup").click(function () {
      $(".your-learning-popup").fadeOut("fast");
    });
    $(".your-learning-popup-content").click(function (e) {
      e.stopPropagation();
    });
  }

  /* set colors of learning popup */
  $(".your-learning-popup-content").css(
    "background-color",
    yourLearningPopupConfig.popupBackgroundColor,
  );
  $(".your-learning-header, .your-learning-sub-header, .yl-course-counter").css(
    "color",
    yourLearningPopupConfig.popupTextColor,
  );
  /* show learning popup */
  $(".your-learning-popup").css("display", "block");
  imageLazyLoader.update();
  var modalLearningContent = document.querySelector(".your-learning-content");

  modalLearningContent.addEventListener("scroll", (event) => {
    imageLazyLoader.update();
  });
}

$(window).on("load", function () {
  /* only show popup on page objects and for logged in Students with at least 1
  registered course */
  if (
    $(".sj-page-catalog").length &&
    typeof skilljarUser !== "undefined" &&
    ($('.coursebox-container[data-course-status="registered"]').length ||
      $(".coursebox-container[data-path]").find(".sj-ribbon-registered").length)
  ) {
    /* add button to DOM of page */
    $("body").append(
      '<button id="learning-popup-btn">View Your Learning</button>',
    );

    /* floating button text/color configuration */
    $("#learning-popup-btn").html(yourLearningPopupConfig.buttonText);
    $("#learning-popup-btn").css(
      "background-color",
      yourLearningPopupConfig.buttonBackgroundColor,
    );
    $("#learning-popup-btn").css(
      "color",
      yourLearningPopupConfig.buttonTextColor,
    );
    if (yourLearningPopupConfig.buttonPosition == "right") {
      $("#learning-popup-btn").css("left", "unset");
      $("#learning-popup-btn").css("right", "15px");
    }
    /* show your learning popup when floating button is clicked */
    $("#learning-popup-btn").click(showLearningPopup);
    imageLazyLoader.update();
  }
});

// ======================================= //
// auto-redirect on course curriculum page //
// when no lessons are complete            //
// ======================================= //

/**
 * This is a code snippet provided by SkillJar
 * to auto-redirect on course curriculum page
 * when no lessons are complete
 *
 * Related learning article:
 * https://developer.skilljar.com/redirect-user-to-1st-lesson-in-course-or-1st-course-in-path-after-registration/1757866?reg=1
 */

/* NOTE: A Course must have the 'auto-redirect' tag applied for this script to kick in */
$(window).on("load", function () {
  /* auto-redirect on course curriculum page when no lessons are complete */
  if (
    $('#main-container[data-tags*="auto-redirect"]').length &&
    $(".sj-page-curriculum").length
  ) {
    /* check if there are 0 lessons complete in this course */
    if (!$(".lesson-complete").length) {
      /* redict user to first lesson if 0 lessons are complete */
      window.location.href = $("#curriculum-list .lesson-incomplete")
        .first()
        .attr("href");
    }
  }
});

/* NOTE: A Path must have the 'auto-redirect' tag applied for this script to kick in */
$(window).on("load", function () {
  /* auto-redirect on path post-registration page when no courses are registered or complete */
  if (
    $('#main-container[data-tags*="auto-redirect"]').length &&
    $(".sj-page-path").length
  ) {
    /* check if there are 0 registered courses in this path */
    if (
      $(
        '#catalog-courses .coursebox-container:not(.not-found)[data-course-status="unregistered"]',
      ).length ==
      $("#catalog-courses .coursebox-container:not(.not-found)").length
    ) {
      /* redirect user to first course in path */
      window.location.href = $("#path-curriculum-resume-button").attr("href");
    }
  }
});

/* Skilljar snippet
Handles partner domain home page card display bug
*/
if (
  window.location.host === "partner.clickup.com" &&
  document.body.classList.contains("home-page")
) {
  let trainingCard = document.querySelector(
    '[data-catalog-page="live-training"]',
  );
  let viewBtn = document.createElement("div");
  viewBtn.classList.add(
    "course-series-count",
    "path-item-count",
    "coursebox-callout",
  );
  viewBtn.innerText = "View";
  viewBtn.style.display = "block";
  trainingCard.append(viewBtn);
}

/* Skilljar snippet
Auto Apply Training Credit Script
*/
$("document").ready(function () {
  /* if on course details page and TC price present, add to purchase button */
  if ($(".sj-page-detail .credits-code__text").length) {
    $(".purchase-button-full-text").text(
      $(".purchase-button-full-text").first().text().trim() +
        " or " +
        $(".credits-code__link").text().trim().substr(14),
    );
  }

  /* if we are on the checkout page, move forward */
  if ($(".sj-page-checkout").length) {
    /* hide quantity drop down entirely */
    $(".sj-text-quantity").parent().css("display", "none");

    var trainingCreditFlag = false;
    var trainingCreditCode = "";
    var today = new Date().toJSON().slice(0, 10);
    $.each(skilljarUserStudentGroups, function (index, group) {
      if (group.training_credit_codes.length !== 0) {
        $.each(group.training_credit_codes, function (index, trainingCredit) {
          if (
            trainingCredit["expiration_date"].substring(
              0,
              trainingCredit["expiration_date"].length - 9,
            ) > today ||
            trainingCredit["expiration_date"] == ""
          ) {
            trainingCreditFlag = true;
            trainingCreditCode = trainingCredit["training_credit_code"];
          }
        });
      }
    });

    /* hide the "can be purchased with X credits" text */
    $(".sj-text-price-credits").parent().css("display", "none");

    /* user has active training credit code, so add "apply" button */
    if (trainingCreditFlag == true) {
      /* hide promo code box */
      $(".sj-text-promotion-code").parent().css("display", "none");

      /* hide subtotal box to clear up space */
      $(".payment-review-order .small-3.columns.text-right").css(
        "display",
        "none",
      );

      $("#promo-code-val").val(trainingCreditCode);
      $("#promo-code-submit").click();

      /* add a button to apply the training credit code
      $('.sj-text-promotion-code').parent().parent().append('<div class="tc-button-wrapper"><span class="tc-button-text">You have a credit for this course:</span><button class="apply-tc-button">Apply Credit</button></div>');

      $('.apply-tc-button').click(function() {

        $('.apply-tc-button').text("Credit Applied!");
        $('.apply-tc-button').css('pointer-events','none');

      });
      */
    } else {
      /* user does not have training credit code, so only show promo code box */
      $(".sj-text-promotion-code").text("Enter promotion code");
    }
  }
});

/* Skilljar snippet
Training Credits Table on Profile Page
*/
$("document").ready(function () {
  if ($(".sj-page-profile").length) {
    var trainingCreditFlag = false;
    var trainingCreditHTML = "";
    var today = new Date().toJSON().slice(0, 10);
    $.each(skilljarUserStudentGroups, function (index, group) {
      if (group.training_credit_codes.length !== 0) {
        trainingCreditFlag = true;
        $.each(group.training_credit_codes, function (index, trainingCredit) {
          if (
            trainingCredit["expiration_date"].substring(
              0,
              trainingCredit["expiration_date"].length - 9,
            ) > today ||
            trainingCredit["expiration_date"] == ""
          ) {
            trainingCreditHTML =
              trainingCreditHTML +
              '<tr class="tc-table-row"><th>' +
              trainingCredit["training_credit_code"] +
              "</th>" +
              "<th>" +
              trainingCredit["credits_remaining"] +
              "</th>" +
              "<th>" +
              trainingCredit["expiration_date"].substring(
                0,
                trainingCredit["expiration_date"].length - 9,
              ) +
              "</th></tr>";
          }
        });
      }
    });

    if (trainingCreditFlag == true) {
      $(".sj-userinfo-data").append(
        '<div class="tc-table-wrapper"><h4>Workshop Credit</h4></div>',
      );
      var tableHTML =
        '<table class="tc-table"><tr class="tc-table-header"><th>Credit Code</th><th>Remaining Balance</th><th>Expiration Date</th></tr></table>';
      $(".tc-table-wrapper").append(tableHTML);
      $(".tc-table").append(trainingCreditHTML);
    }
  }
});

/* Skilljar snippet
Corner Pop Up Announcement
*/
/* Below you will find options to configure corner pop-ups to show up on
specific URLs in your Skilljar domain. Supports courses, lessons, pages, etc */
var popupConfig = {
  "pop-up1": {
    /* Set the below line to the title you want to display for the pop-up. Supports HTML. */
    title: "More workshops coming soon!",
    /* Set the below line to the text you want to display in the pop-up. Supports HTML. */
    message: `New live sessions with exciting use cases are on the way. Have any ideas for use cases you'd like to see? Email us at <a href="mailto:training@clickup.com?subject=ClickUp University: Future Workshops">training@clickup.com</a>!`,
    /* Set the below variable to true if you want to only show the announcement to each user once */
    showOnlyOnce: "false",
    backgroundColor: "#ffffff" /* background color of pop-up */,
    textColor: "#222" /* color of text in pop-up */,
    linkColor: "#7b68ee" /* color of link in pop-up (optional) */,
    /* Set the URLs you want to show the announcement on below. Use '/' for all URLs.
     -Supports fuzzy matching. Ex: 'onboarding' would show on 'onboarding-course' and 'onboarding-path'
     -Supports multiple URLs. Surround URLs in quotes and add a comma between each entry.
     -To show the ribbon on your home page, add 'show-on-home' as a URL
     -Examples have been added below, feel free to edit/remove them */
    showOnURLs: ["/page/live-training"],
    /* (Optional) Set the link text and destination URL on the two lines below. Leave blank for no link. */
    linkText: "",
    linkDestination: "",
    /* If you want the link to open in a new tab, set the below value to true */
    openLinkInNewTab: "true",
  },
};

$(window).on("load", function () {
  $.each(popupConfig, function (index, popupData) {
    var storageIdentifier = index;
    /* show announcement only on specific page URLs */
    if (popupData.showOnURLs.length !== 0) {
      $.each(popupData.showOnURLs, function (index2, urlWhitelist) {
        if (
          window.location.href.includes(urlWhitelist) ||
          (urlWhitelist.toLowerCase() == "show-on-home" &&
            $(".sj-page-catalog-root").length)
        ) {
          if (localStorage.getItem(storageIdentifier) !== "clicked") {
            var popup = `
              <div class="popup">
                <span class="popup-close">&times;</span>
                <div class="popup-title"></div>
                <div class="popup-text"></div>
              </div>
            `;

            $("body").append(popup);

            $(".popup-close").click(function () {
              if (popupData.showOnlyOnce == "true") {
                localStorage.setItem(index, "clicked");
              }

              $(".popup").fadeOut("slow");
            });

            $(".popup-title").html(popupData.title);
            $(".popup .popup-text").html(popupData.message);

            /* append link to announcement text if it isn't blank */
            if (popupData.linkText !== "" && popupData.linkDestination !== "") {
              if (popupData.openLinkInNewTab == "true") {
                var linkHTML =
                  '<a class="popup-link" href="' +
                  popupData.linkDestination +
                  '" target="_blank"> ' +
                  popupData.linkText +
                  "</a>";
              } else {
                var linkHTML =
                  '<a class="popup-link" href="' +
                  popupData.linkDestination +
                  '"> ' +
                  popupData.linkText +
                  "</a>";
              }
              $(".popup .popup-text").html(
                $(".popup .popup-text").html() + linkHTML,
              );
            }

            $(".popup").css("background-color", popupData.backgroundColor);
            $(".popup-title").css("color", popupData.textColor);
            $(".popup-text").css("color", popupData.textColor);
            $(".popup-link").css("color", popupData.linkColor);

            setTimeout(function () {
              $(".popup").fadeIn("slow");
            }, 1000);
          }
        }
      });
    }
  });
});

/**
 * Please do not insert code after the above SkillJar function(s)
 */
